import { Modal, Button } from "rsuite";

type modalProps = {
  id?: number;
  modalType?: string | null;
  openModal: boolean;
  handleCloseModal: () => void;
  modalTitle: string;
  children: JSX.Element | null;
  handleConfirm?: () => void;
  disableModalBtn?: boolean;
};

const ReusableModal = ({
  modalType,
  modalTitle,
  openModal,
  handleCloseModal,
  children,
  handleConfirm,
  disableModalBtn,
}: modalProps) => {
  const handleFormScroll = (e: React.UIEvent<HTMLElement>) => {
    e.preventDefault();

    const datePickerElem: HTMLElement | null = document.querySelector(
      ".rs-picker-date-menu"
    );

    datePickerElem?.classList.add("d-none");
  };

  return (
    <div className="modal-container">
      <Modal
        size="md"
        backdrop={`static`}
        open={openModal}
        onClose={handleCloseModal}
      >
        <Modal.Header>
          <Modal.Title>
            <span className="modal-title">{modalTitle}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body onScroll={handleFormScroll} className="mb-4 modalBody">
          {children}
        </Modal.Body>
        <Modal.Footer
          className={
            modalType === "form" ||
            modalType === "regulation" ||
            modalType === "edit"
              ? "d-none"
              : ""
          }
        >
          <Button
            disabled={disableModalBtn}
            onClick={() => handleCloseModal()}
            appearance="subtle"
          >
            Cancel
          </Button>
          <Button
            disabled={disableModalBtn}
            onClick={() => {
              if (handleConfirm) {
                handleConfirm();
              }
            }}
            className="primary-color"
            appearance="primary"
            loading={disableModalBtn}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReusableModal;
